import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RequestComponent} from './components/request-page/request.component';
import {ConfiguratorComponent} from './components/configurator/configurator.component';
import {ListComponent} from './components/list/list.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'main/uploadRequest/requests',
    pathMatch: 'full'
  },
  {
    path: 'uploadRequest/request/:id',
    component: RequestComponent
  },
  {
    path: 'main/uploadRequest/request/:id',
    component: RequestComponent
  },
  {
    path: 'main/uploadRequest/config/create',
    component: ConfiguratorComponent
  },
  {
    path: 'main/uploadRequest/config',
    component: ConfiguratorComponent
  },
  {
    path: 'main/uploadRequest/config/create/:id',
    component: ConfiguratorComponent
  },
  {
    path: 'main/uploadRequest/config/edit/:id',
    component: ConfiguratorComponent
  },
  {
    path: 'main/uploadRequest/requests',
    component: ListComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
